import React from 'react'
import style from './Footer.module.scss'
import commonStyle from '../../style.module.scss'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

interface IFooterProps {
  findability: boolean
  showCart: boolean
  showMain: boolean
  totals: number
  onHomeClick: () => void
  onCartOpen: () => void
  showHint: () => void
  closeSimulation: () => void
}

const Footer = ({
  findability,
  showCart,
  showMain,
  totals,
  onHomeClick,
  onCartOpen,
  showHint,
  closeSimulation
}: IFooterProps) => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  return (
    <>
      {viewport.mobile ? (
        <footer className={style.footerMobile} data-testid="SW-EC-Footer">
          <EmptyLink color="#0060A9">
            <div className={style.footerItem}>
              <div className={style.exploreIcon} />
              <div className={style.footerItemText}>{t('questions', 'ec', 'costco', 'explore')}</div>
            </div>
          </EmptyLink>
          <button className={`${style.footerItem} ${showMain ? style.footerItemActive : ''}`} onClick={onHomeClick}>
            <div className={style.shopIcon} />
            <div className={style.footerItemText}>{t('questions', 'ec', 'costco', 'shop')}</div>
          </button>
          {findability ? (
            <EmptyLink color="#0060A9">
              <div className={style.footerItem}>
                <div className={style.cartIcon} />
                <div className={style.footerItemText}>{t('questions', 'ec', 'costco', 'cart')}</div>
              </div>
            </EmptyLink>
          ) : (
            <button className={`${style.footerItem} ${showCart ? style.footerItemActive : ''}`} onClick={onCartOpen}>
              <div className={style.counter}>{totals > 99 ? '99+' : totals}</div>
              <div className={style.cartIcon} />
              <div className={style.footerItemText}>{t('questions', 'ec', 'costco', 'cart')}</div>
            </button>
          )}
          <div className={style.footerItem}>
            <div className={`${commonStyle.IconAytmPlace}`}>
              <i className=" icon-aytmfd-help" onClick={showHint} />
            </div>
          </div>
          <div className={style.footerItem}>
            <div className={`${commonStyle.IconAytmPlace}`}>
              <i className=" icon-aytmfd-exit" onClick={closeSimulation} />
            </div>
          </div>
        </footer>
      ) : (
        <footer className={style.footer} data-testid="SW-EC-Footer">
          <div className={style.footerInner}>
            <div className={style.controls}>
              <div className={style.topSection}>
                <div className={style.title}>{t('questions', 'ec', 'costco', 'customerService')}</div>
                <EmptyLink color="#0060A9">
                  <div className={style.content}>
                    <div className={style.signIcon} />
                    <div className={style.signText}>{t('questions', 'ec', 'costco', 'getHelp')}</div>
                  </div>
                </EmptyLink>
              </div>
              <div className={style.topSection}>
                <div className={style.title}>{t('questions', 'ec', 'costco', 'findWarehouse')}</div>
                <EmptyLink color="#0060A9">
                  <div className={style.input}>
                    <div className={style.inputText}>{t('questions', 'ec', 'costco', 'address')}</div>
                    <div className={style.searchIcon} />
                  </div>
                </EmptyLink>
              </div>
            </div>
            <div className={style.links}>
              <div className={style.linkColumn}>
                <div className={style.linkTitle}>{t('questions', 'ec', 'costco', 'aboutUs')}</div>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'knowCostco')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'contributions')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'info')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'commitment')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'investor')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'careers')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'kirkland')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'logo')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'connection')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'digitalConnection')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'videos')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'site')}</div>
                </EmptyLink>
              </div>
              <div className={style.linkColumn}>
                <div className={style.linkTitle}>{t('questions', 'ec', 'costco', 'membership')}</div>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'membershipInfo')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'executiveBenefits')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'join')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'privileges')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'membershipTerms')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'refer')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'register')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'credit')}</div>
                </EmptyLink>
                <div className={style.linkTitle}>{t('questions', 'ec', 'costco', 'vendors')}</div>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'inquiries')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'disclosure')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'ethics')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'inclusion')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'exploreBrands')}</div>
                </EmptyLink>
              </div>
              <div className={style.linkColumn}>
                <div className={style.linkTitle}>{t('questions', 'ec', 'costco', 'customerService')}</div>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'costcoCustomerService')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'cardBalance')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'itemNumber')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'support')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'domestic')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'orderStatus')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'fraud')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'shipping')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'rebates')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'recalls')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'exchanges')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'returnPolicy')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'accessibility')}</div>
                </EmptyLink>
              </div>
              <div className={style.linkColumn}>
                <div className={style.linkTitle}>{t('questions', 'ec', 'costco', 'locationsServices')}</div>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'findWarehouse')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'locationsSoon')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'closures')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'gasoline')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'aidCenter')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'optical')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'specialEvents')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'costcoGrocery')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'instacart')}</div>
                </EmptyLink>
                <EmptyLink color="#0060A9">
                  <div className={style.link}>{t('questions', 'ec', 'costco', 'collections')}</div>
                </EmptyLink>
              </div>
            </div>
            <div className={style.privacyLinks}>
              <EmptyLink color="#0060A9">
                <div className={style.privacyItem}>{t('questions', 'ec', 'costco', 'siteMap')}</div>
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.privacyItem}>{t('questions', 'ec', 'costco', 'terms')}</div>
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.privacyItem}>{t('questions', 'ec', 'costco', 'yourPrivacy')}</div>
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.privacyItem}>{t('questions', 'ec', 'costco', 'caNotice')}</div>
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.privacyItem}>{t('questions', 'ec', 'costco', 'socialCompliance')}</div>
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.privacyItem}>{t('questions', 'ec', 'costco', 'cookie')}</div>
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.privacyItem}>
                  <div className={style.privacyIcon} />
                  {t('questions', 'ec', 'costco', 'yourPrivacyChoices')}
                </div>
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.privacyItem}>{t('questions', 'ec', 'costco', 'consumerHealthData')}</div>
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.privacyItem}>{t('questions', 'ec', 'costco', 'feedback')}</div>
              </EmptyLink>
            </div>
            <div className={style.logos}>
              <EmptyLink color="#0060A9">
                <div className={style.logoFb} />
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.logoPn} />
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.logoIn} />
              </EmptyLink>
              <EmptyLink color="#0060A9">
                <div className={style.logoCo} />
              </EmptyLink>
            </div>
            <div className={style.allRights}>{t('questions', 'ec', 'costco', 'allRigths')}</div>
          </div>
        </footer>
      )}
    </>
  )
}
export default Footer
